import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils & misc
import cn from '../../../utils/cn';
import { parseFontAwesomeClass } from '../../../utils/fontawesome/config';

// Style
import style from './NavigationButton.module.css';

/**
 * NavigationButton component - A navigation button with icon, label and states
 * @param {object} params
 * @param {string} params.id - Id of the button
 * @param {(event: React.MouseEvent<HTMLButtonElement>) => void} params.onClick - Click handler function
 * @param {string | null} [params.icon=null] - Icon name from available pictos
 * @param {string} params.label - Button text label
 * @param {boolean} [params.isActive=false] - Whether the button is in active state
 * @param {boolean} [params.isMenuOpen=false] - Whether the menu is open
 * @param {string} [params.className] - Additional CSS classes
 * @param {React.ReactNode | null} [params.children] - Children elements
 * @param {'default' | 'submenu'} [params.theme='default'] - Theme of the button
 * @returns {JSX.Element} NavigationButton component
 */
function NavigationButton({
  id,
  onClick,
  icon = null,
  label,
  isActive = false,
  isMenuOpen = false,
  className,
  children = null,
  theme = 'default',
}) {
  const iconDefinition = parseFontAwesomeClass(icon);

  return (
    <button
      id={id}
      type="button"
      className={cn([
        style['navigation-button'],
        style[theme],
        isActive && style.active,
        isMenuOpen && style['menu-open'],
        className,
      ])}
      onClick={onClick}
      tabIndex={isMenuOpen ? 0 : -1}
      title={label}
    >
      <div className={style.content}>
        {iconDefinition && theme === 'default' ? (
          <div className={cn([style.icon])}>
            <FontAwesomeIcon icon={/** @type {any} */ (iconDefinition)} />
          </div>
        ) : null}
        <span className={cn([style.label])}>
          {label}
        </span>
      </div>

      {children}
    </button>
  );
}

export default NavigationButton;
